import React, { useState, useEffect, useRef, useContext } from 'react';
import { Grid, useTheme } from "@mui/material";
import { useFormContext } from '../Context/Context';
import { useLocation } from 'react-router-dom';
import { useInputValues } from '../Context/InputValuesContext';
import { useErrorContext } from '../Context/ErrorContext';
import { useReadOnly } from '../Context/ReadOnlyContext';
import { FinalValuesContext } from '../Context/FinalValuesContext';
import ConvertTitle from './ConvertTitle';
import EditableInput from './FullName/EditableInput';
import { getInitialValues, updateDrawerState, validateName } from './FullName/fullNameHelpers';

const FullName = ({ id, header }) => {
  const { drawerData } = useFormContext();
  const { inputValues } = useInputValues();
  const { setMistake } = useErrorContext();
  const { readOnly } = useReadOnly();
  const { finalSelectValues } = useContext(FinalValuesContext);

  const location = useLocation();
  const currentPage = location.pathname;
  const existingComponentIndex = drawerData.findIndex(c => c.id === id);
  const { nameValue: initName, firstNameValue: initFirst, lastNameValue: initLast, firstNameInput: initInputFirst, lastNameInput: initInputLast } =
    getInitialValues(drawerData, existingComponentIndex, readOnly);

  const [nameValue, setNameValue] = useState(initName);
  const [firstNameValue, setFirstNameValue] = useState(initFirst);
  const [lastNameValue, setLastNameValue] = useState(initLast);
  const [firstNameInput, setFirstNameInput] = useState(initInputFirst);
  const [lastNameInput, setLastNameInput] = useState(initInputLast);
  const [error, setError] = useState('');
  const [errorLastName, setErrorLastName] = useState('');
  const [border, setBorder] = useState(false);
  const [condition, setCondition] = useState(false);

  const gridRef = useRef(null);
  const theme = useTheme();
  const HeadingColor = theme.palette.blue[700];
  const titleIndex = finalSelectValues.findIndex(item => item.name === "FieldCondition");
  const title = ConvertTitle({ title: finalSelectValues[titleIndex]?.value });
  const isReadOnly = currentPage.startsWith('/publish') || currentPage.startsWith('/user/fill-form/');

  useEffect(() => {
    updateDrawerState(drawerData, existingComponentIndex, {
      nameValue, firstNameValue, lastNameValue, mainFirstNameInput: firstNameInput, mainLastNameInput: lastNameInput
    }, readOnly);
  }, [nameValue, firstNameValue, lastNameValue, firstNameInput, lastNameInput]);

  useEffect(() => {
    const dataIndex = drawerData.findIndex(item => item.title === title);
    const dataCondition = drawerData[dataIndex]?.state.readOnly;
    setCondition(currentPage === '/Publish' && (readOnly || dataCondition) && title === "FullName");
  }, [finalSelectValues, readOnly]);

  const handleFirstNameInput = (e) => {
    const value = e.target.value;
    setFirstNameInput(value);
    setError(validateName(value) ? '' : inputValues?.find(item => item.name === "ThisFieldCanOnlyContainLetters")?.value || '');
    setMistake(!validateName(value));
  };

  const handleLastNameInput = (e) => {
    const value = e.target.value;
    setLastNameInput(value);
    setErrorLastName(validateName(value) ? '' : inputValues?.find(item => item.name === "ThisFieldCanOnlyContainLetters")?.value || '');
    setMistake(!validateName(value));
  };

  const handleOutsideClick = (e) => {
    if (gridRef.current && !gridRef.current.contains(e.target)) setBorder(false);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  return (
    <Grid
      ref={gridRef}
      onClick={() => setBorder(true)}
      border={border && drawerData[existingComponentIndex] && !isReadOnly ? '2px solid #0293e2' : '2px solid transparent'}
      bgcolor="white"
      p="12px"
      mb="28px"
      borderRadius="3px"
    >
      <input
        value={nameValue}
        onChange={(e) => setNameValue(e.target.value)}
        style={{
          border: 'none', outline: 'none', fontWeight: 700, fontSize: '16px',
          color: HeadingColor, width: '100%'
        }}
        readOnly={isReadOnly || condition}
        placeholder="یک عنوان وارد کنید"
      />
      <Grid display="flex" gap="16px" my="8px">
        <EditableInput value={firstNameInput} onChange={handleFirstNameInput} readOnly={condition} error={error} />
        <EditableInput value={lastNameInput} onChange={handleLastNameInput} readOnly={condition} error={errorLastName} />
      </Grid>
      <Grid display="flex" gap="16px">
        <input value={firstNameValue} onChange={(e) => setFirstNameValue(e.target.value)} readOnly={isReadOnly || condition} placeholder="SubLabel نام" style={{ width: '100%', fontSize: '12px', border: 'none', color: '#b8bdc9' }} />
        <input value={lastNameValue} onChange={(e) => setLastNameValue(e.target.value)} readOnly={isReadOnly || condition} placeholder="SubLabel خانوادگی" style={{ width: '100%', fontSize: '12px', border: 'none', color: '#b8bdc9' }} />
      </Grid>
    </Grid>
  );
};

export default FullName;
